module.exports = __webpack_public_path__ + "img/infoDiagram-logo-top-banner.04a9479.png";